import http from "./httpService";

const baseUrl = `/mcp-connections`;

// { connectorUrl, connections: [{ id, clientName, adminName, createdAt, lastUsedAt, ... }] }
export const getMcpConnections = async () => {
  try {
    const { data } = await http.get(baseUrl);
    return data;
  } catch (err) {
    return null;
  }
};

export const disconnectMcpConnection = async (id) => {
  try {
    await http.delete(`${baseUrl}/${id}`);
    return true;
  } catch (err) {
    return false;
  }
};
